let blockLinks = [];

export const blockLink = {
    onDocumentLoad
}

const onDocumentLoad = function() {
  /*Handle clicks for blocks with links*/
  blockLinks = document.querySelectorAll(".block-link");
  for (let i = 0; i < blockLinks.length; i++) {
    blockLinks[i].addEventListener("click", blockLinkPress);

    blockLinks[i].addEventListener("keyup", function (e) {
      if (e.key === "Enter") {
        blockLinkPress(e);
      }
    });
  }

  function blockLinkPress(e) {
    let item = e.currentTarget.querySelector("[href]");
    let link = item.getAttribute("href");
    let target = item.getAttribute("target");
    let download = item.getAttribute("download")

    if(target != null && target == "_blank") {
      window.open(link, '_blank');
    } else {
      if(download != null) {
        window.open(link, '_blank');
      } else {
        window.location.href = link;
      }
    }
  }
}